import { apiFetch } from "../utils/apiFetch";
import React, { useState } from "react";
import { FiLoader } from "react-icons/fi";

const RemoveMembers = ({
  setMemberRemovePopup,
  memberRemovePopup,
  setMembers,
  workspace,
}) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const handleRemove = async () => {
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const res = await apiFetch(
        `${process.env.API_URL}/api/workspace/${workspace._id}/members/${memberRemovePopup.id}`,
        {
          method: "DELETE",
          },
      );

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || data.error || "Could not remove member. Please try again.");
      await setMembers((prev) =>
        prev.filter(
          (memberInfo) =>
            String(memberInfo.userId._id) !== String(data.removedId),
        ),
      );
      setMemberRemovePopup(null);
    } catch (err) {
      setError(err.message);
    } finally { setBusy(false); }
  };

  return (
    <div
      onClick={() => !busy && setMemberRemovePopup(null)}
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog" aria-modal="true" aria-labelledby="remove-member-title"
        className="w-[calc(100%_-_2rem)] max-w-md bg-white rounded-lg p-6"
      >
        <div className="flex flex-col gap-2 text-center sm:text-left">
          <h2 id="remove-member-title" className="text-lg font-semibold">Remove Member</h2>
          <p className="text-gray-600 text-sm">
            Are you sure you want to remove{" "}
            <strong>{memberRemovePopup.username.toUpperCase()}</strong> from
            this channel? They will lose access to channel content and announcements.
          </p>
          <p className="text-sm text-gray-600">Removing access does not cancel an existing subscription.</p>
        </div>
        {error && <p role="alert" className="mt-3 text-sm text-red-700">{error}</p>}
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end mt-6">
          <button
            disabled={busy}
            onClick={() => setMemberRemovePopup(null)}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-9 px-4 py-2 has-[>svg]:px-3"
          >
            Cancel
          </button>
          <button
            disabled={busy}
            onClick={handleRemove}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive text-white h-9 px-4 py-2 has-[>svg]:px-3 bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            {busy ? <FiLoader aria-label="Removing member" className="animate-spin" /> : "Remove"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveMembers;
